var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { api_service } from '../../../api/api_service';
import { api_urls } from '../../../api/api_urls';
import { utility } from '../../../utils';
import constants from '../../../config/constants';
import _ from '../../../utils/lodash';
import { deepEqual } from '../../../utils/commonUtilities';
import HeaderLogo from '../../../assets/images/Auxilior-Logo-BW-Horizontal-White.png';
import LandingPageLogo from '../../../assets/images/Auxilior-Logo-BW-Vertical-White.png';
import LoginScreenLogo from '../../../assets/images/Auxilior-Logo-BW-Horizontal-Black.png';
import LandingPageBackgroundLogo from '../../../assets/images/defaultBG.png';
import { IMAGE_MIME_TYPES, DEFAULT_FONT_STYLE, DEFAULT_PRIMARY_THEME_COLOR, DEFAULT_SECONDARY_THEME_COLOR, LOGO_FIELDS, PDF_FILE_KEYS, PDF_MIME_TYPE, BRANDING_FIELD_KEYS, BRANDING_FILE_KEYS, CONFIG_PAYLOAD_KEYS, TAB_ERROR_KEYS, TAB_STATE_KEYS, FIELD_CONFIG_REQUIRED_MESSAGE, createFieldConfigDefaults, createPortalDefaults, initialBlobFiles, initialCreateErrors, initialErrors, initialPortalConfig, } from './portalDetail.constants';
import { isFieldConfigValid, jsonToFormData, parseJsonContent, validateField } from './portalDetail.utils';
var DEFAULT_IMAGES = [
    { name: 'LandingLogo', path: HeaderLogo, fileName: 'Auxilior-Logo-BW-Horizontal-White.png' },
    { name: 'LoginLogo1', path: LandingPageLogo, fileName: 'Auxilior-Logo-BW-Horizontal-White.png' },
    { name: 'LoginLogo2', path: LoginScreenLogo, fileName: 'Auxilior-Logo-BW-Vertical-Black.png' },
    { name: 'LoginBackground', path: LandingPageBackgroundLogo, fileName: 'defaultBG.png' },
];
var pick = function (source, keys) {
    return keys.reduce(function (accumulator, key) {
        var _a;
        return (__assign(__assign({}, accumulator), (_a = {}, _a[key] = source[key], _a)));
    }, {});
};
var revokeBlobUrl = function (url) {
    if (typeof url === 'string' && url.startsWith('blob:'))
        URL.revokeObjectURL(url);
};
var fetchDefaultImages = function () { return __awaiter(void 0, void 0, void 0, function () {
    var files;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                files = {};
                return [4, Promise.all(DEFAULT_IMAGES.map(function (image) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, blob, error_1;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, 3, , 4]);
                                    return [4, fetch(image.path)];
                                case 1:
                                    response = _a.sent();
                                    if (!response.ok)
                                        throw new Error("HTTP error! Status: ".concat(response.status));
                                    return [4, response.blob()];
                                case 2:
                                    blob = _a.sent();
                                    files[image.name] = new File([blob], image.fileName, { type: blob.type });
                                    return [3, 4];
                                case 3:
                                    error_1 = _a.sent();
                                    console.log('fetchDefaultImages ~ err:', image.name, error_1);
                                    return [3, 4];
                                case 4: return [2];
                            }
                        });
                    }); }))];
            case 1:
                _a.sent();
                return [2, files];
        }
    });
}); };
var emptyFieldConfig = { nor: { json: {} }, loc: { json: {} }, sch: { json: {} } };
export var usePortalConfig = function (vendorId, mode) {
    if (mode === void 0) { mode = 'edit'; }
    var isCreate = mode === 'create';
    var baseErrors = isCreate ? initialCreateErrors : initialErrors;
    var _a = useState(function () { return (__assign({}, (isCreate ? createPortalDefaults : initialPortalConfig))); }), portal = _a[0], setPortal = _a[1];
    var _b = useState(function () { return (__assign({}, (isCreate ? createPortalDefaults : initialPortalConfig))); }), savedPortal = _b[0], setSavedPortal = _b[1];
    var _c = useState(__assign({}, initialBlobFiles)), blobFiles = _c[0], setBlobFiles = _c[1];
    var _d = useState(__assign({}, baseErrors)), errors = _d[0], setErrors = _d[1];
    var _e = useState(false), isFetching = _e[0], setIsFetching = _e[1];
    var _f = useState(isCreate), isLoaded = _f[0], setIsLoaded = _f[1];
    var _g = useState(''), loadError = _g[0], setLoadError = _g[1];
    var _h = useState(false), isSaving = _h[0], setIsSaving = _h[1];
    var _j = useState({}), programRows = _j[0], setProgramRows = _j[1];
    var _k = useState([]), programOptions = _k[0], setProgramOptions = _k[1];
    var _l = useState({}), defaultImages = _l[0], setDefaultImages = _l[1];
    var _m = useState(function () { return (isCreate ? createFieldConfigDefaults() : emptyFieldConfig); }), fieldConfig = _m[0], setFieldConfig = _m[1];
    var isDirty = useMemo(function () { return !deepEqual(portal, savedPortal); }, [portal, savedPortal]);
    var isTabDirty = useCallback(function (tab) { return !deepEqual(pick(portal, TAB_STATE_KEYS[tab]), pick(savedPortal, TAB_STATE_KEYS[tab])); }, [portal, savedPortal]);
    var loadPortal = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var res, data, programs_1, error_2;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    setIsFetching(true);
                    setLoadError('');
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, 4, 5]);
                    return [4, api_service.get({
                            endPoint: api_urls.DEALER_DETAILS_BY_ID,
                            payLoad: { VendorId: vendorId },
                        })];
                case 2:
                    res = _c.sent();
                    if (((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.statusCode) === 200) {
                        data = res.data.data;
                        programs_1 = (data === null || data === void 0 ? void 0 : data.Programs) || [];
                        data.ProgramIds = programs_1.map(function (program) { return ({ label: program.Name, value: program.Id }); });
                        setProgramRows(function (prev) {
                            var next = __assign({}, prev);
                            programs_1.forEach(function (program) {
                                next[String(program.Id)] = program;
                            });
                            return next;
                        });
                        delete data.Programs;
                        setPortal(data);
                        setSavedPortal(_.cloneDeep(data));
                        setBlobFiles(__assign({}, initialBlobFiles));
                        setIsLoaded(true);
                    }
                    else {
                        setLoadError(((_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.message) || 'We could not load this portal.');
                    }
                    return [3, 5];
                case 3:
                    error_2 = _c.sent();
                    console.log('loadPortal ~ err:', error_2);
                    setLoadError('We could not load this portal. Please check your connection and try again.');
                    return [3, 5];
                case 4:
                    setIsFetching(false);
                    return [7];
                case 5: return [2];
            }
        });
    }); }, [vendorId]);
    var loadPrograms = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var res, rows_1, error_3;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4, api_service.get({ endPoint: api_urls.PROGRAMS_LIST })];
                case 1:
                    res = _b.sent();
                    if (((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.statusCode) === 200 && res.data.data) {
                        rows_1 = res.data.data;
                        setProgramOptions(rows_1.map(function (row) { return ({ label: row.Name, value: row.Id }); }));
                        setProgramRows(function (prev) {
                            var next = __assign({}, prev);
                            rows_1.forEach(function (row) {
                                next[String(row.Id)] = __assign(__assign({}, next[String(row.Id)]), row);
                            });
                            return next;
                        });
                    }
                    return [3, 3];
                case 2:
                    error_3 = _b.sent();
                    console.log('Error:', error_3);
                    return [3, 3];
                case 3: return [2];
            }
        });
    }); }, []);
    var loadFieldConfig = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var res, response, error_4;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    return [4, api_service.get({
                            endPoint: "".concat(api_urls.GET_FIELD_CONFIG_DATA, "?VendorId=").concat(vendorId),
                            showLoader: true,
                        })];
                case 1:
                    res = _c.sent();
                    if (((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.statusCode) === 200) {
                        response = res.data.data;
                        if (response) {
                            setFieldConfig({
                                nor: { json: response.NORJson },
                                loc: { json: response.LOCJson },
                                sch: { json: response.SCHJson },
                            });
                        }
                    }
                    else {
                        utility.alert((_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.message);
                    }
                    return [3, 3];
                case 2:
                    error_4 = _c.sent();
                    console.log('loadFieldConfig ~ err:', error_4);
                    return [3, 3];
                case 3: return [2];
            }
        });
    }); }, [vendorId]);
    var loadDefaultImages = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = setDefaultImages;
                    return [4, fetchDefaultImages()];
                case 1:
                    _a.apply(void 0, [_b.sent()]);
                    return [2];
            }
        });
    }); }, []);
    useEffect(function () {
        if (!(vendorId > 0))
            return;
        loadPortal();
        loadFieldConfig();
    }, [vendorId, loadPortal, loadFieldConfig]);
    useEffect(function () {
        loadPrograms();
        loadDefaultImages();
    }, [loadPrograms, loadDefaultImages]);
    var setToggle = useCallback(function (name, checked) {
        var dependent = {
            IsActivationCodeEnabled: 'defaultActivationCode',
            IsInsuranceOptionEnabled: 'DefaultInsuranceConsent',
            IsDealerRateAdjustmentEnabled: 'DealerRateAdjustmentType',
        };
        var clears = !checked ? dependent[name] : undefined;
        setPortal(function (prev) {
            var _a, _b;
            return (__assign(__assign(__assign({}, prev), (_a = {}, _a[name] = checked ? 1 : 0, _a)), (clears ? (_b = {}, _b[clears] = '', _b) : {})));
        });
        if (clears)
            setErrors(function (prev) {
                var _a;
                return (__assign(__assign({}, prev), (_a = {}, _a[clears] = '', _a)));
            });
    }, []);
    var setField = useCallback(function (name, value) {
        setPortal(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[name] = value, _a)));
        });
        setErrors(function (prev) {
            var _a;
            return (name in prev ? __assign(__assign({}, prev), (_a = {}, _a[name] = '', _a)) : prev);
        });
    }, []);
    var setPrograms = useCallback(function (values) {
        setPortal(function (prev) { return (__assign(__assign({}, prev), { ProgramIds: values })); });
    }, []);
    var setDefaultLogo = useCallback(function (name, flag, checked) {
        if (checked) {
            var file_1 = defaultImages[name];
            if (!file_1)
                return;
            var url_1 = URL.createObjectURL(file_1);
            setPortal(function (prev) {
                var _a;
                revokeBlobUrl(prev["".concat(name, "Url")]);
                return __assign(__assign({}, prev), (_a = {}, _a[name] = file_1, _a["".concat(name, "Url")] = url_1, _a[flag] = 1, _a));
            });
            setBlobFiles(function (prev) {
                var _a;
                return (__assign(__assign({}, prev), (_a = {}, _a[name] = file_1, _a)));
            });
        }
        else {
            setPortal(function (prev) {
                var _a;
                revokeBlobUrl(prev["".concat(name, "Url")]);
                return __assign(__assign({}, prev), (_a = {}, _a[name] = '', _a["".concat(name, "Url")] = '', _a[flag] = 0, _a));
            });
            setBlobFiles(function (prev) {
                var _a;
                return (__assign(__assign({}, prev), (_a = {}, _a[name] = '', _a)));
            });
        }
    }, [defaultImages]);
    var selectFile = useCallback(function (name, file) {
        if (!file)
            return;
        if (PDF_FILE_KEYS.includes(name) && file.type !== PDF_MIME_TYPE) {
            utility.alert('Please upload a valid file');
            return;
        }
        if (!PDF_FILE_KEYS.includes(name) && !IMAGE_MIME_TYPES.includes(file.type)) {
            utility.alert('Please upload a valid file');
            return;
        }
        var url = URL.createObjectURL(file);
        var logo = LOGO_FIELDS.find(function (item) { return item.name === name; });
        setPortal(function (prev) {
            var _a, _b;
            revokeBlobUrl(prev["".concat(name, "Url")]);
            return __assign(__assign(__assign({}, prev), (_a = {}, _a[name] = file, _a["".concat(name, "Url")] = url, _a)), ((logo === null || logo === void 0 ? void 0 : logo.defaultFlag) ? (_b = {}, _b[logo.defaultFlag] = 0, _b) : {}));
        });
        setBlobFiles(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[name] = file, _a)));
        });
    }, []);
    var removeFile = useCallback(function (name) {
        var logo = LOGO_FIELDS.find(function (item) { return item.name === name; });
        setBlobFiles(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[name] = '', _a)));
        });
        setPortal(function (prev) {
            var _a, _b;
            revokeBlobUrl(prev["".concat(name, "Url")]);
            return __assign(__assign(__assign({}, prev), (_a = {}, _a[name] = '', _a["".concat(name, "Url")] = '', _a)), ((logo === null || logo === void 0 ? void 0 : logo.defaultFlag) ? (_b = {}, _b[logo.defaultFlag] = 0, _b) : {}));
        });
    }, []);
    var resetChanges = useCallback(function (tab) {
        if (!tab) {
            setPortal(_.cloneDeep(savedPortal));
            setBlobFiles(__assign({}, initialBlobFiles));
            setErrors(__assign({}, baseErrors));
            return;
        }
        setPortal(function (prev) {
            if (tab === 'branding')
                BRANDING_FILE_KEYS.forEach(function (key) { return revokeBlobUrl(prev["".concat(key, "Url")]); });
            return __assign(__assign({}, prev), _.cloneDeep(pick(savedPortal, TAB_STATE_KEYS[tab])));
        });
        if (tab === 'branding')
            setBlobFiles(__assign({}, initialBlobFiles));
        setErrors(function (prev) {
            var next = __assign({}, prev);
            TAB_ERROR_KEYS[tab].forEach(function (key) {
                if (key in next)
                    next[key] = '';
            });
            return next;
        });
    }, [savedPortal, baseErrors]);
    var validate = useCallback(function (tab) {
        var keys = Object.keys(baseErrors).filter(function (key) { return !tab || TAB_ERROR_KEYS[tab].includes(key); });
        var next = {};
        keys.forEach(function (key) {
            next[key] = validateField(key, portal, savedPortal);
        });
        if (keys.includes('FieldConfig')) {
            next.FieldConfig = isFieldConfigValid(fieldConfig) ? '' : FIELD_CONFIG_REQUIRED_MESSAGE;
        }
        setErrors(function (prev) { return (__assign(__assign({}, prev), next)); });
        return keys.filter(function (key) { return next[key] !== ''; });
    }, [portal, savedPortal, fieldConfig, baseErrors]);
    var validateOne = useCallback(function (name) {
        if (!(name in baseErrors))
            return;
        setErrors(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[name] = validateField(name, portal, savedPortal), _a)));
        });
    }, [portal, savedPortal, baseErrors]);
    var buildTabPayload = useCallback(function (tab) {
        var payload = { VendorId: vendorId };
        var keys = tab === 'configurations' ? CONFIG_PAYLOAD_KEYS : BRANDING_FIELD_KEYS;
        keys.forEach(function (key) {
            var value = portal[key];
            if (value !== '' && value !== null && value !== undefined)
                payload[key] = value;
        });
        if (tab === 'configurations') {
            payload.ProgramIds = (portal.ProgramIds || []).map(function (item) { return Number(item.value); });
        }
        else {
            BRANDING_FILE_KEYS.forEach(function (key) {
                if (portal[key] instanceof File)
                    payload[key] = portal[key];
            });
        }
        return payload;
    }, [portal, vendorId]);
    var putConfig = useCallback(function (tab) { return __awaiter(void 0, void 0, void 0, function () {
        var res;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4, api_service.put({
                        endPoint: api_urls.UPDATE_DEALER_CONFIG,
                        headerType: api_service.ContentHeaders.FormData,
                        payLoad: jsonToFormData(buildTabPayload(tab)),
                        showLoader: true,
                    })];
                case 1:
                    res = _c.sent();
                    if (((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.statusCode) === 200)
                        return [2, true];
                    utility.alert((_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.message);
                    return [2, false];
            }
        });
    }); }, [buildTabPayload]);
    var deleteRemovedFiles = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var fileUrls, res;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    fileUrls = {};
                    Object.keys(blobFiles).forEach(function (key) {
                        if (!portal[key] && savedPortal["".concat(key, "Url")]) {
                            fileUrls["".concat(key, "Url")] = savedPortal["".concat(key, "Url")];
                        }
                    });
                    if (!Object.keys(fileUrls).length)
                        return [2, true];
                    return [4, api_service.put({
                            endPoint: api_urls.DELETE_DEALER_FILES,
                            payLoad: { VendorId: vendorId, FileUrls: [fileUrls] },
                            showLoader: true,
                        })];
                case 1:
                    res = _c.sent();
                    if (((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.statusCode) === 200)
                        return [2, true];
                    utility.alert((_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.message);
                    return [2, false];
            }
        });
    }); }, [blobFiles, portal, savedPortal, vendorId]);
    var save = useCallback(function (tab) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, error_5;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setIsSaving(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 6, 7, 8]);
                    _a = tab === 'branding';
                    if (!_a) return [3, 3];
                    return [4, deleteRemovedFiles()];
                case 2:
                    _a = !(_b.sent());
                    _b.label = 3;
                case 3:
                    if (_a)
                        return [2, false];
                    return [4, putConfig(tab)];
                case 4:
                    if (!(_b.sent()))
                        return [2, false];
                    return [4, loadPortal()];
                case 5:
                    _b.sent();
                    utility.alert('Configuration has been saved successfully.', constants.TOAST_TYPES.INFO);
                    return [2, true];
                case 6:
                    error_5 = _b.sent();
                    console.log('save ~ err:', error_5);
                    return [2, false];
                case 7:
                    setIsSaving(false);
                    return [7];
                case 8: return [2];
            }
        });
    }); }, [deleteRemovedFiles, putConfig, loadPortal]);
    var saveFieldConfig = useCallback(function (next) { return __awaiter(void 0, void 0, void 0, function () {
        var nor, loc, sch, res, error_6;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    nor = parseJsonContent(next.nor);
                    loc = parseJsonContent(next.loc);
                    sch = parseJsonContent(next.sch);
                    if (nor === false || loc === false || sch === false) {
                        utility.alert('One of the JSON payloads is invalid. Please fix it before saving.', 'error');
                        return [2, false];
                    }
                    if (isCreate) {
                        setFieldConfig({ nor: { json: nor }, loc: { json: loc }, sch: { json: sch } });
                        setErrors(function (prev) { return (__assign(__assign({}, prev), { FieldConfig: '' })); });
                        return [2, true];
                    }
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4, api_service.put({
                            endPoint: api_urls.SAVE_OR_UPDATE_FIELD_CONFIG,
                            payLoad: { VendorId: vendorId, NORJson: nor, LOCJson: loc, SCHJson: sch },
                            showLoader: true,
                        })];
                case 2:
                    res = _c.sent();
                    if (((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.statusCode) === 200) {
                        setFieldConfig({ nor: { json: nor }, loc: { json: loc }, sch: { json: sch } });
                        setErrors(function (prev) { return (__assign(__assign({}, prev), { FieldConfig: '' })); });
                        return [2, true];
                    }
                    utility.alert((_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.message);
                    return [3, 4];
                case 3:
                    error_6 = _c.sent();
                    console.log('saveFieldConfig ~ err:', error_6);
                    return [3, 4];
                case 4: return [2, false];
            }
        });
    }); }, [vendorId, isCreate]);
    var createdVendorId = useRef(null);
    var createPortal = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var payload_1, images_1, _a, created, newVendorId, configRes, error_7;
        var _b, _c, _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    setIsSaving(true);
                    _f.label = 1;
                case 1:
                    _f.trys.push([1, 7, 8, 9]);
                    if (!(createdVendorId.current === null)) return [3, 5];
                    payload_1 = _.cloneDeep(portal);
                    Object.keys(payload_1).forEach(function (key) {
                        if (payload_1[key] === '' || payload_1[key] === null)
                            delete payload_1[key];
                    });
                    payload_1.ProgramIds = (portal.ProgramIds || []).map(function (item) { return parseInt(String(item.value), 10); });
                    payload_1.FontStyle = portal.FontStyle || DEFAULT_FONT_STYLE;
                    payload_1.PrimaryThemeColor = portal.PrimaryThemeColor || DEFAULT_PRIMARY_THEME_COLOR;
                    payload_1.SecondaryThemeColor = portal.SecondaryThemeColor || DEFAULT_SECONDARY_THEME_COLOR;
                    images_1 = defaultImages;
                    if (!DEFAULT_IMAGES.some(function (image) { return !images_1[image.name]; })) return [3, 3];
                    _a = [__assign({}, images_1)];
                    return [4, fetchDefaultImages()];
                case 2:
                    images_1 = __assign.apply(void 0, _a.concat([(_f.sent())]));
                    _f.label = 3;
                case 3:
                    LOGO_FIELDS.forEach(function (_a) {
                        var name = _a.name, defaultFlag = _a.defaultFlag;
                        if (!defaultFlag)
                            return;
                        var defaultFile = images_1[name];
                        payload_1[defaultFlag] = defaultFile ? 1 : 0;
                        if (defaultFile)
                            payload_1[name] = defaultFile;
                    });
                    return [4, api_service.post({
                            endPoint: api_urls.CREATE_DEALER,
                            headerType: api_service.ContentHeaders.FormData,
                            payLoad: jsonToFormData(payload_1),
                            showLoader: true,
                        })];
                case 4:
                    created = _f.sent();
                    if (((_b = created === null || created === void 0 ? void 0 : created.data) === null || _b === void 0 ? void 0 : _b.statusCode) !== 200) {
                        utility.alert((_c = created === null || created === void 0 ? void 0 : created.data) === null || _c === void 0 ? void 0 : _c.message);
                        return [2, null];
                    }
                    createdVendorId.current = Number(created.data.data.VendorId);
                    _f.label = 5;
                case 5:
                    newVendorId = createdVendorId.current;
                    return [4, api_service.put({
                            endPoint: api_urls.SAVE_OR_UPDATE_FIELD_CONFIG,
                            payLoad: {
                                IsNew: 1,
                                VendorId: newVendorId,
                                NORJson: parseJsonContent(fieldConfig.nor),
                                LOCJson: parseJsonContent(fieldConfig.loc),
                                SCHJson: parseJsonContent(fieldConfig.sch),
                            },
                            showLoader: true,
                        })];
                case 6:
                    configRes = _f.sent();
                    if (((_d = configRes === null || configRes === void 0 ? void 0 : configRes.data) === null || _d === void 0 ? void 0 : _d.statusCode) !== 200) {
                        utility.alert((_e = configRes === null || configRes === void 0 ? void 0 : configRes.data) === null || _e === void 0 ? void 0 : _e.message);
                        utility.alert('The portal was created, but its field configuration could not be saved. Press Create Portal again to retry.', constants.TOAST_TYPES.WARN);
                        return [2, null];
                    }
                    return [2, newVendorId];
                case 7:
                    error_7 = _f.sent();
                    console.log('createPortal ~ err:', error_7);
                    return [2, null];
                case 8:
                    setIsSaving(false);
                    return [7];
                case 9: return [2];
            }
        });
    }); }, [portal, fieldConfig, defaultImages]);
    return {
        portal: portal,
        errors: errors,
        isFetching: isFetching,
        isLoaded: isLoaded,
        loadError: loadError,
        reload: loadPortal,
        isSaving: isSaving,
        isDirty: isDirty,
        isTabDirty: isTabDirty,
        programOptions: programOptions,
        programRows: programRows,
        fieldConfig: fieldConfig,
        isFieldConfigValid: isFieldConfigValid,
        setToggle: setToggle,
        setField: setField,
        setPrograms: setPrograms,
        setDefaultLogo: setDefaultLogo,
        selectFile: selectFile,
        removeFile: removeFile,
        resetChanges: resetChanges,
        validate: validate,
        validateOne: validateOne,
        save: save,
        createPortal: createPortal,
        saveFieldConfig: saveFieldConfig,
        isCreate: isCreate,
    };
};
